/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { CancelReservationCreditPurchasePathParameters } from 'api/actions/cancel-reservation-credit-purchase/cancel-reservation-credit-purchase-path-parameters';
import { CancelReservationCreditPurchaseResponse } from 'api/actions/cancel-reservation-credit-purchase/cancel-reservation-credit-purchase-response';

type CancelReservationCreditPurchaseQueryParameters = Record<string, any>;

/**
 * The path of the CancelReservationCreditPurchase action.
 */
export const cancelReservationCreditPurchaseActionPath = new SweetPath<
  keyof CancelReservationCreditPurchasePathParameters
>('/reservations/credits/purchases/{purchaseId}/cancel', { path: '{param}' });

/**
 * Creates a contextualized CancelReservationCreditPurchase actions.
 */
export default function createCancelReservationCreditPurchaseAction(axios: AxiosInstance) {
  return function cancelReservationCreditPurchaseAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: CancelReservationCreditPurchasePathParameters;
    query?: CancelReservationCreditPurchaseQueryParameters;
  }) {
    const path = cancelReservationCreditPurchaseActionPath.insert(parameters);

    return axios.post<CancelReservationCreditPurchaseResponse, CancelReservationCreditPurchaseResponse>(path, {
      params: query,
      headers,
    });
  };
}
